module.exports = __webpack_public_path__ + "img/4C.23c51e0b.png";